
var userAgent = function(){
	var agent = {
			os: undefined,
			device: undefined
		},
        define = function() {
			var agentAll = ['ipod','iphone','ipad', 'android'],
				i = 0;

			for(i;i< agentAll.length;i++){
				var re = new RegExp(agentAll[i], 'i');
				if( re.test( navigator.userAgent ) ) {
                    agent.device = agentAll[i];

                    if(agentAll[i] === 'android') agent.os = 'android';
                    else agent.os = 'ios';

                    break;
				}
			}
		};

	//
	define();
	return agent;

};


export {userAgent};

